import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CustomerService } from "app/api/services";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxPrintModule } from "ngx-print";

@Component({
  selector: "app-select-for-pressure-dialog",
  templateUrl: "./select-for-pressure-dialog.component.html",
  styleUrls: ["./select-for-pressure-dialog.component.scss", "./../../../../_styles/calibration-overrides.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FlexLayoutModule,
    DragScrollModule,
    NgxPrintModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
  ]
})
export class SelectForPressureDialogComponent implements OnInit {
  public loadcells: number[];
  public includedLoadcellIds: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectForPressureDialogComponent>,
    public customerService: CustomerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data != null) {
      this.customerService
        .apiCustomerCustomerPressureLoadcellsGet$Json({
          customerId: this.data.customerId,
        })
        .subscribe((res) => {
          if (!res) return;

          this.includedLoadcellIds.push(this.data?.loadcellId);
          this.loadcells = res?.data;
        });
    }
  }

  toggleIncludeCell(cell: number, $event: any) {
    if ($event.checked) {
      this.includedLoadcellIds?.push(cell);
    } else {
      this.includedLoadcellIds?.splice(
        this.includedLoadcellIds?.findIndex((x) => x == cell)
      );
    }
  }

  isIncluded(cell: number) {
    return this.includedLoadcellIds?.includes(cell);
  }

  close(returnData: boolean) {
    this.dialogRef.close(returnData ? this.includedLoadcellIds : null);
  }
}
